"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getInsuranceCard } from "@/src/requests/insurance-card";
export const INSURANCE_CARD_CACHE_KEY = "insurance-card";
export function useInsuranceCard(patientId, coverageId, departmentId) {
  const $ = _c(12);
  const t0 = departmentId ?? null;
  let t1;
  if ($[0] !== coverageId || $[1] !== patientId || $[2] !== t0) {
    t1 = [INSURANCE_CARD_CACHE_KEY, patientId, coverageId, t0];
    $[0] = coverageId;
    $[1] = patientId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== coverageId || $[5] !== departmentId || $[6] !== patientId) {
    t2 = () => getInsuranceCard(patientId, coverageId, departmentId);
    $[4] = coverageId;
    $[5] = departmentId;
    $[6] = patientId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = Boolean(patientId && coverageId);
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: 300000
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const query = useQuery(t4);
  return query.data ?? null;
}